export const currencyStringToNumber = s => {
  if (typeof s === 'undefined' || s === null || s === '') {
    return null
  }
  const n = parseInt(s, 10)
  if (Number.isNaN(n)) {
    return null
  }
  return Math.round(n * 100)
}
